import React, { useState,} from 'react';
import Card from 'react-bootstrap/Card';
import { LuEdit } from 'react-icons/lu';

import './SectionResult.css';

export default function SectionResult(props) {

  const [result, setResult] = useState(true)

  const recalculateExpense = () => {
    setResult(true)
    props.refresh()
  }

  return (<>
    {
      result

      ?
      <Card>
          <Card.Header>
              <h3>
                {props.title}
                {(props.form !== undefined) ? <LuEdit style={{float:'right', color: "red"}} size={25} onClick={() => setResult(false)}/> : null}
              </h3>
          </Card.Header>

          <Card.Body>
              <div className="grid">
                  <div></div>
                  <div  style={{textAlign:'right'}}>{(props.semester === "Both" || props.semester === "Fall") ? "Fall" : ""}</div>
                  <div  style={{textAlign:'right'}}>{(props.semester === "Both" || props.semester === "Spring") ? "Spring" : ""}</div>
              </div>
              <hr/>
              {
                props.data.slice(1).map( ({name, spring, fall}, i) => (
                  <div className="grid" key={i}>
                      <div>{name}</div>
                      <div  style={{textAlign:'right'}}>{(props.semester === "Both" || props.semester === "Fall") ? (fall).toLocaleString("en-US", {style: 'currency', currency: 'USD'}) : ""}</div>
                      <div  style={{textAlign:'right'}}>{(props.semester === "Both" || props.semester === "Spring") ? (spring).toLocaleString("en-US", {style: 'currency', currency: 'USD'}) : ""}</div>
                  </div>
                ) )
              }
              <hr/>
              <div className="grid">
                  <div>{props.data[0].name}</div>
                  <div  style={{textAlign:'right', color: '#C8102E'}}>{(props.semester === "Both" || props.semester === "Fall") ? (props.data[0].fall).toLocaleString("en-US", {style: 'currency', currency: 'USD'}) : ""}</div>
                  <div  style={{textAlign:'right', color: '#C8102E'}}>{(props.semester === "Both" || props.semester === "Spring") ? (props.data[0].spring).toLocaleString("en-US", {style: 'currency', currency: 'USD'}) : ""}</div>
              </div>
          </Card.Body>
      </Card>
      
      :

      <>
        {props.form}
        <div style={{textAlign: 'center', padding: 20}}>  
          <button className="hoverable" onClick={() => (props.isSectionValid()) ? recalculateExpense() : null}>DONE</button>
        </div>
      </>           
    }
  </>)
}